<template>
  <div class="row pb-5 accordion-element">
    <div class="col">
      <Accordion>
        <AccordionTab>
           <template #header>
              <td>Informations supplémentaires </td>
              <vue-loaders v-if="isDataLoading == true" name="ball-beat"></vue-loaders>
           </template>
          <div class="row">
            <div class="col-2 lbl">
              <label>Particularités :</label>
            </div>
            <div class="col-10 text-left txt">
              <p v-if="!particularites"> ... </p>
              <span v-for="particularite in particularites" :key="particularite.cle">[{{ particularite }}]
                <span v-if="particularite != particularites[particularites.length - 1]">&emsp;</span>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Site d'origine:</label>
                </div>
                <div class="col txt">
                  <p v-if="!siteAfficher"> ... </p>
                  <p v-else> {{ siteAfficher }} </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Province :</label>
                </div>
                <div class="col txt">
                  <p v-if="!provinceAfficher"> ... </p>
                  <p v-else> {{ provinceAfficher }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label>Date de création :</label>
                </div>
                <div class="col txt">
                  <p v-if="!creerLe"> ... </p>
                  <p v-else> {{ creerLe }} </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Confidentialité :</label>
                </div>
                <div class="col txt">
                  <p v-if="!confidentialiteAfficher"> ... </p>
                  <p v-else> {{ confidentialiteAfficher }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label>Créé par :</label>
                </div>
                <div class="col txt">
                  <p v-if="!creerParDescription"> ... </p>
                  <p v-else> {{ creerParDescription }} </p>
                </div>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InformationSupplementaire',
  props: ['isDataLoading','particularites', 'siteAfficher', 'provinceAfficher', 
          'creerLe', 'confidentialiteAfficher', 'creerParDescription', 'creerPar'],
}
</script>